// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__SIL4B","title":"Profile_title__3Sl7C","body":"Profile_body__1oMv3","content":"Profile_content__iENs7"};